export default "__VITE_ASSET__B2U7HB4p__"